export default __webpack_public_path__ + "static/Corporate_Responsibility_Philanthropic_MB_03-7498bea1aa470ebf0ca4be0cea23bf8b.jpg";